export default __webpack_public_path__ + "static/media/restaurado.6fc2fd1c.svg";